import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const bg = {
  common: {
    app_name: "OfferTrace",
    tagline: "Всяка оферта получава отговор.",
    loading: "Зареждане…",
    save: "Запази",
    cancel: "Отказ",
    delete: "Изтрий",
    edit: "Редактирай",
    close: "Затвори",
    yes: "Да",
    no: "Не",
    back: "Назад",
    search: "Търсене",
    empty: "Няма записи",
    required: "Задължително поле",
    invalid_email: "Невалиден имейл",
    error_generic: "Възникна грешка. Опитайте отново.",
    unauthorized: "Нямате достъп до тази страница.",
    switch_organization: "Смени организация",
    copy: "Копирай",
    copied: "Копирано",
    open_link: "Отвори връзка",
    signed_download: "Изтегли (защитен)",
    from: "от",
    to: "до",
    total: "Общо",
    filter: "Филтър",
    all: "Всички",
    date: "Дата",
    value: "Стойност",
    status: "Статус",
  },
  auth: {
    sign_in: "Вход",
    sign_up: "Регистрация",
    sign_out: "Изход",
    email: "Имейл",
    password: "Парола",
    full_name: "Име и фамилия",
    organization_name: "Име на организация",
    have_account: "Имате акаунт?",
    no_account: "Нямате акаунт?",
    create_account: "Създай акаунт",
    welcome_back: "Добре дошли отново",
    create_your_account: "Създайте акаунта си",
    setup_org: "Настройте организацията си",
    signup_note: "Ще създадем акаунта и организацията за вас",
    check_email: "Проверете имейла си за потвърждение (ако е нужно).",
    forgot_password: "Забравена парола?",
  },
  nav: {
    dashboard: "Табло",
    quotations: "Оферти",
    customers: "Клиенти",
    users: "Потребители",
    notifications: "Известия",
    settings: "Настройки",
    profile: "Профил",
    menu: "Отвори менюто",
    close_menu: "Затвори менюто",
    primary: "Основна навигация",
  },
  dashboard: {
    title: "Табло",
    subtitle: "Общ преглед на офертите и активностите",
    total_active: "Активни оферти",
    sent: "Изпратени",
    opened: "Отворени",
    attention: "Изискват внимание",
    accepted: "Приети",
    declined: "Отказани",
    expired: "Изтекли",
    open_value: "Стойност на активни",
    accepted_value: "Стойност на приети",
    // Phase 2A.1 keys
    period_label: "Период",
    period_from: "От",
    period_to: "До",
    period_today: "Днес",
    period_last_7: "Последните 7 дни",
    period_last_30: "Последните 30 дни",
    period_last_90: "Последните 90 дни",
    period_this_month: "Този месец",
    period_last_month: "Миналият месец",
    period_this_year: "Тази година",
    period_custom: "Персонализиран",
    period_apply: "Приложи",
    timezone_note: "Часова зона: Европа/София",
    section_period_kpis: "Показатели за периода",
    section_current_kpis: "Текущо състояние",
    section_funnel: "Фуния на продажбите",
    section_trend: "Тенденция на приетата стойност",
    section_aging: "Възраст на офертите без отговор",
    kpi_sent_count: "Изпратени",
    kpi_opened_count: "Отворени",
    kpi_responded_count: "С отговор",
    kpi_accepted_from_cohort: "Приети (от периода)",
    kpi_declined_from_cohort: "Отказани (от периода)",
    kpi_accepted_value_period: "Стойност на приетите за периода",
    kpi_avg_time_to_open: "Средно време до отваряне",
    kpi_avg_time_to_response: "Средно време до отговор",
    kpi_conversion_pct: "Конверсия",
    kpi_open_rate_pct: "Дял на отворените",
    kpi_response_rate_pct: "Дял на отговорилите",
    kpi_awaiting_response: "Без отговор",
    kpi_expiring_7: "Изтичащи до 7 дни",
    kpi_expired_current: "Изтекли",
    kpi_active_value: "Активна стойност",
    sub_of_sent: "от изпратените",
    sub_pct_conversion: "приети / изпратени",
    stage_sent: "Изпратени",
    stage_opened: "Отворени",
    stage_responded: "С отговор",
    stage_accepted: "Приети",
    aging_bucket_0_3: "0–3 дни",
    aging_bucket_4_7: "4–7 дни",
    aging_bucket_8_14: "8–14 дни",
    aging_bucket_15_plus: "15+ дни",
    aging_column_range: "Диапазон",
    aging_column_count: "Брой",
    aging_column_value: "Стойност",
    aging_empty: "Няма чакащи оферти в момента.",
    trend_empty: "Няма приети оферти за избрания период.",
    trend_bucket_day: "по ден",
    trend_bucket_week: "по седмица",
    trend_bucket_month: "по месец",
    trend_x_axis: "Период",
    trend_y_axis: "Стойност (EUR)",
    trend_tooltip_count: "Брой приети",
    trend_tooltip_value: "Обща стойност",
    click_hint: "Клик за детайли",
    last_updated: "Последно обновяване",
    refreshing: "Обновяване…",
    loading: "Зареждане на данните…",
    error_load: "Данните не се заредиха. Опитайте отново.",
    retry: "Опитай пак",
    duration_seconds: "{{seconds}} сек",
    duration_minutes: "{{minutes}} мин",
    duration_hours: "{{hours}} ч",
    duration_days: "{{days}} дни",
    duration_none: "—",
    // Phase 2A.2 — ownership
    owner_filter_label: "Отговорник",
    owner_filter_all: "Всички",
    owner_filter_mine: "Моите оферти",
    owner_filter_unassigned: "Неразпределени",
    kpi_unassigned_current: "Неразпределени оферти",
    section_by_owner: "Резултати по търговец",
    by_owner_column_owner: "Търговец",
    by_owner_column_sent: "Изпратени",
    by_owner_column_opened: "Отворени",
    by_owner_column_responded: "С отговор",
    by_owner_column_accepted: "Приети",
    by_owner_column_declined: "Отказани",
    by_owner_column_accepted_value: "Стойност на приетите",
    by_owner_column_acceptance_rate: "Дял на приетите",
    by_owner_column_avg_response: "Средно до отговор",
    by_owner_column_awaiting: "Без отговор",
    by_owner_empty: "Няма данни за периода.",
    by_owner_mixed_currency: "Смесени валути — сумата е само за EUR оферти",
    by_owner_disclaimer: "Приписване към текущия отговорник. Преразпределението мести историческите суми.",
    unassigned_row_label: "Неразпределени",
    unassigned_disabled_when_owner_filtered: "Изчистете филтъра по търговец, за да видите неразпределените.",
    // Phase 2D.3B.3 — глобален обхват (период · екип · отговорник)
    scope_title: "Обхват на таблото",
    refresh_now: "Обнови",
    scope_team_label: "Екип",
    scope_team_all: "Всички екипи",
    scope_team_unassigned: "Без екип",
    scope_team_locked: "Вашият екип",
    scope_team_locked_hint: "Виждате данните само на екипа, който управлявате.",
    scope_team_none: "Все още нямате екип.",
    scope_owner_label: "Отговорник",
    scope_owner_all: "Всички отговорници",
    scope_owner_unassigned: "Без отговорник",
    scope_note: "Данните в таблото се обновяват спрямо избрания екип и период.",
    scope_period_note: "Показателите за периода зависят от избраните дати.",
    scope_current_note: "Текущото състояние не зависи от избрания период.",
    section_period: "Активност за избрания период",
    section_period_help: "Показва какво се е случило с офертите през избрания период.",
    section_current_state: "Състояние на офертите в момента",
    section_current_state_help:
      "Показва текущия статус и активната стойност независимо от избрания период.",
    section_status_distribution: "Разпределение по статус",
    section_statuses_now: "Статуси в момента",
    section_by_team: "Представяне по екип",
    section_workload: "Активни оферти по служител",
    section_secondary: "Допълнителен анализ",
    status_draft: "Чернови",
    status_sent: "Изпратени",
    status_opened: "Отворени",
    status_question: "С въпрос",
    status_accepted: "Приети",
    status_declined: "Отказани",
    status_expired: "Изтекли",
    status_archived: "Архивирани",
    statuses_total: "общо",
    statuses_empty: "Няма оферти за избрания обхват.",
    by_team_column_team: "Екип",
    by_team_column_open: "Отворени оферти",
    by_team_column_active_value: "Активна стойност",
    by_team_column_awaiting: "Без отговор",
    by_team_column_expiring: "Изтичащи до 7 дни",
    by_team_no_team: "Без екип",
    by_team_archived_suffix: " (архивиран)",
    by_team_empty: "Няма активни оферти за избрания обхват.",
    by_team_note: "Активните оферти се отчитат по екипа, към който принадлежат в момента.",
    workload_column_employee: "Служител",
    workload_column_role: "Роля",
    workload_column_team: "Екип",
    workload_column_open: "Активни оферти",
    workload_column_active_value: "Активна стойност",
    workload_column_awaiting: "Без отговор",
    workload_column_expiring: "Изтичащи",
    workload_empty: "Няма активни оферти за избрания обхват.",
    workload_no_team: "Без екип",
    workload_unassigned: "Неразпределени",
    workload_note: "Текущо натоварване по отговорник — независимо от избрания период.",
    mixed_currency_note: "Смесени валути — сумите включват само офертите в EUR.",
  },
  quotations: {
    title: "Оферти",
    new: "Нова оферта",
    list_empty: "Все още нямате оферти. Създайте първата си.",
    // Sales quotation isolation: one honest message for a quotation that does
    // not exist AND for one the current user has no access to — the two cases
    // must never be distinguishable.
    not_accessible: "Офертата не е намерена или нямате достъп до нея.",
    reference: "№ на оферта",
    customer: "Клиент",
    value: "Стойност",
    status: "Статус",
    responsible: "Отговорник",
    // Phase 2A.2 — ownership
    owner_column: "Отговорник",
    owner_field_label: "Отговорен търговец",
    owner_unassigned: "Неразпределена",
    owner_inactive_suffix: " (неактивен)",
    owner_sales_default_hint: "Автоматично зададен на вас",
    change_owner: "Промени отговорника",
    change_owner_title: "Смяна на отговорника",
    change_owner_current: "Текущ отговорник",
    change_owner_new: "Нов отговорник",
    change_owner_confirm: "Потвърди",
    change_owner_success: "Отговорникът е променен.",
    change_owner_noop: "Няма промяна.",
    change_owner_error: "Не може да се промени отговорника. Опитайте отново.",
    change_owner_forbidden: "Само собственик може да променя отговорника.",
    // Phase 2D.3B.2 — прехвърляне в рамките на екипа от мениджър
    reassign_team_member: "Прехвърли към търговец",
    reassign_title: "Прехвърляне на офертата",
    reassign_new: "Нов отговорник от екипа",
    reassign_not_open: "Само активна оферта може да се прехвърля. Приключените запазват своя отговорник.",
    reassign_stale: "Отговорникът е променен междувременно. Презаредете офертата и опитайте отново.",
    reassign_forbidden: "Можете да прехвърляте само между активни търговци от вашия екип.",
    sender_label: "Изпратена от",
    filter_owner_placeholder: "Филтър по отговорник",
    my_quotations: "Моите оферти",
    unassigned_quotations: "Неразпределени",
    event_owner_assigned_to: "Офертата е възложена на {{owner}}.",
    event_owner_changed: "Отговорникът е променен от {{prev}} на {{next}}.",
    event_owner_unassigned: "Офертата е преместена в „Неразпределени“.",
    event_owner_taken: "Офертата е поета от {{owner}}.",
    // ---
    created: "Създадена",
    valid_until: "Валидна до",
    last_activity: "Последна активност",
    filter_all: "Всички",
    st: {
      draft: "Чернова",
      sent: "Изпратена",
      opened: "Отворена",
      question: "Въпрос",
      accepted: "Приета",
      declined: "Отказана",
      expired: "Изтекла",
      archived: "Архивирана",
    },
    fields: {
      title: "Заглавие",
      reference: "№ на оферта",
      customer: "Клиент",
      customer_email: "Клиентски имейл",
      customer_phone: "Клиентски телефон",
      value: "Стойност",
      currency: "Валута",
      valid_until: "Валидна до",
      internal_notes: "Вътрешни бележки",
      upload: "Прикачи файл (PDF / DOCX / XLSX)",
    },
    reference_label: "Номер на офертата",
    reference_auto_hint: "Предложен автоматично от OfferTrace",
    reference_in_use: "Този номер на оферта вече се използва.",
    reference_locked_hint: "Номерът на изпратена оферта вече не може да се променя.",
    renew: "Поднови офертата",
    renew_title: "Подновяване на {{reference}}",
    renew_submit: "Създай подновена оферта",
    renew_valid_until: "Нова валидност до",
    renew_file_label: "Файл",
    renew_file_reuse: "Използвай текущия файл",
    renew_file_new: "Качи нов файл",
    renew_file_none: "Без файл засега",
    renew_source_file_missing: "Първоначалната оферта няма прикачен файл.",
    renew_file_copy_failed:
      "Подновената оферта е създадена, но файлът не беше копиран. Качете файл в новата оферта.",
    renew_file_upload_failed:
      "Подновената оферта е създадена, но файлът не беше качен. Опитайте отново от новата оферта.",
    renewed_as: "Подновена като {{reference}}",
    renewed_from: "Подновена от {{reference}}",
    renewal_open: "Отвори подновената оферта",
    renewal_open_source: "Отвори първоначалната оферта",
    create: "Създай оферта",
    save_draft: "Запази чернова",
    mark_sent: "Маркирай като изпратена",
    copy_link: "Копирай връзка",
    revoke_link: "Отмени връзка",
    recover_link: "Възстанови връзка",
    archive: "Архивирай",
    // Phase 2C.2 — archive end to end
    archive_confirm_title: "Архивиране на оферта",
    archive_confirm_body: "Офертата ще бъде преместена в архива и няма да се показва сред активните оферти.",
    archive_confirm_action: "Архивирай",
    archive_submitting: "Архивиране…",
    archive_success: "Офертата е архивирана.",
    archive_already: "Офертата вече е архивирана.",
    archive_error: "Офертата не може да бъде архивирана. Опитайте отново.",
    archive_forbidden: "Можете да архивирате само оферти, за които отговаряте.",
    archive_conflict: "Статусът на офертата се промени. Презаредете страницата.",
    archived_banner_title: "Тази оферта е архивирана",
    archived_banner_body: "Архивираните оферти не се показват сред активните и не приемат нови отговори от клиента.",
    archived_at_label: "Архивирана на",
    revoke_confirm_title: "Отмяна на публичната връзка",
    revoke_confirm_body: "Връзката ще спре да работи и клиентът няма да може да отвори офертата. Това не може да бъде отменено.",
    revoke_confirm_action: "Отмени връзката",
    revoke_submitting: "Отмяна…",
    revoke_error: "Връзката не може да бъде отменена. Опитайте отново.",
    view_label: "Изглед",
    view_active: "Активни",
    view_archived: "Архивирани",
    view_all: "Всички",
    archived_list_empty: "Няма архивирани оферти.",
    detail: "Детайли на офертата",
    timeline: "Хронология",
    customer_info: "Информация за клиент",
    original_file: "Оригинален файл",
    preview: "Преглед",
    download_file: "Изтегли файл",
    public_link: "Публична връзка",
    no_file: "Няма прикачен файл",
    no_active_link: "Няма активна публична връзка",
    generate_link: "Генерирай връзка",
    // Phase 2B.1 — email
    email_send: "Изпрати по имейл",
    email_resend: "Изпрати отново",
    email_history_title: "Имейл история",
    callback_requested_badge: "Клиентът поиска обратно обаждане",
    email_history_empty: "Все още не е изпращан имейл.",
    email_dialog_title: "Изпращане на офертата по имейл",
    email_dialog_recipient: "Получател",
    email_dialog_subject: "Тема",
    email_dialog_message: "Съобщение",
    email_dialog_from: "От",
    email_dialog_reply_to: "Отговори на",
    email_dialog_reply_to_none: "Не е конфигуриран",
    email_dialog_secure_link_note: "Имейлът съдържа защитена връзка към офертата.",
    email_dialog_test_banner: "Тестов режим: имейлите се пренасочват към адрес за тестване.",
    email_dialog_confirm_summary: "Проверете преди изпращане:",
    email_dialog_send: "Изпрати",
    email_dialog_confirm: "Потвърди и изпрати",
    email_dialog_cancel: "Отказ",
    email_dialog_disabled_notice: "Изпращането по имейл все още не е активирано.",
    email_status: {
      pending: "Подготвя се",
      sending: "Изпраща се",
      sent: "Изпратен",
      delivered: "Доставен",
      delivery_delayed: "Забавена доставка",
      bounced: "Върнат",
      failed: "Неуспешен",
      complained: "Отбелязан като спам",
      suppressed: "Потиснат",
    },
    email_failure_code: {
      prohibited_status: "Офертата не може да бъде изпратена отново в текущия си статус.",
      quotation_not_found: "Офертата не е намерена или нямате достъп до нея.",
      email_not_found: "Имейлът не е намерен.",
      configuration_error: "Проблем с конфигурацията",
      invalid_recipient: "Невалиден получател",
      rate_limited: "Твърде много опити",
      provider_rejected: "Отказ от доставчика",
      provider_unavailable: "Услугата не е достъпна",
      timeout: "Изтече времето",
      unknown_provider_error: "Неизвестна грешка",
    },
    email_event_email_sent: "Офертата беше изпратена по имейл до {{recipient}}.",
    email_event_email_delivered: "Имейлът беше доставен.",
    email_event_email_delivery_delayed: "Доставката на имейла се забавя.",
    email_event_email_bounced: "Имейлът не беше доставен.",
    email_event_email_failed: "Имейлът не беше изпратен.",
    email_event_email_complained: "Получателят маркира имейла като нежелан.",
    email_check_status: "Провери статуса",
    email_send_error: "Изпращането се провали. Опитайте отново.",
    email_test_mode_badge: "Тестов режим",
    // Phase 2B.2 — readable timeline + delivery alerts
    timeline_details: "Детайли",
    owner_user_fallback: "Потребител",
    email_alert_action: "Към имейл историята",
    email_default_subject: "Оферта {{reference}} от {{organization}}",
    email_default_message: "Здравейте,\n\nИзпращаме Ви нашата оферта. Можете да я прегледате и да изпратите въпрос, да я приемете или откажете чрез защитения бутон по-долу.\n\nПоздрави,\n{{sender}}",
  },
  customers: {
    title: "Клиенти",
    new: "Нов клиент",
    fields: {
      name: "Име",
      email: "Имейл",
      phone: "Телефон",
      company: "Фирма",
      address: "Адрес",
    },
    empty: "Все още нямате клиенти.",
  },
  settings: {
    title: "Настройки на организацията",
    business_info: "Данни на бизнеса",
    logo: "Лого",
    members: "Членове",
    role: "Роля",
    role_owner: "Собственик",
    role_sales: "Продажби",
    only_owner: "Само собствениците могат да променят настройки на организацията.",
  },
  company: {
    title: "Настройки на компанията",
    section_basic: "Основна информация",
    section_contacts: "Контакти",
    section_email: "Имейл комуникация",
    section_identity: "Лого и идентичност",
    section_numbering: "Номериране на офертите",
    quotation_number_prefix: "Префикс на номерата",
    numbering_help:
      "Използва се за автоматичните номера на офертите: ПРЕФИКС-ГОДИНА-НОМЕР. Променя само бъдещите номера.",
    next_reference: "Следваща оферта: {{reference}}",
    next_reference_hint:
      "Информативно. Точният номер се определя в момента на създаване на офертата.",
    name: "Име на компанията",
    legal_name: "Юридическо наименование",
    eik: "ЕИК",
    vat_number: "ДДС номер",
    address: "Адрес",
    phone: "Телефон",
    website: "Уебсайт",
    reply_to_email: "Общ имейл за отговор",
    email_signature: "Подпис в имейлите",
    currency: "Валута по подразбиране",
    logo: "Лого на компанията",
    reply_to_help:
      "Използва се като резервен адрес, когато към офертата няма търговец с валиден имейл.",
    routing_help:
      "Отговорите на клиента се насочват първо към търговеца, отговорен за конкретната оферта.",
    signature_help: "Само текст. Добавя се в имейлите до клиента.",
    sender_notice: "Имейлите се изпращат от името на компанията чрез OfferTrace.",
    save: "Запази промените",
    saving: "Запазване…",
    saved: "Настройките на компанията са запазени.",
    no_changes: "Няма промени за запазване.",
    unsaved: "Имате незапазени промени.",
    readonly_notice:
      "Само собственикът на организацията може да променя настройките на компанията.",
    email_readonly_notice:
      "Настройките за имейл комуникация се управляват от собственика на организацията.",
    logo_upload: "Качи лого",
    logo_replace: "Смени логото",
    logo_remove: "Премахни логото",
    logo_removing: "Премахване…",
    logo_uploading: "Качване…",
    logo_remove_title: "Премахване на логото",
    logo_remove_body:
      "Логото ще бъде премахнато от имейлите и публичните страници на офертите. Можете да качите ново по всяко време.",
    logo_uploaded: "Логото беше запазено.",
    logo_removed: "Логото беше премахнато.",
    logo_hint: "PNG, JPEG или WebP, до 2 MB.",
    logo_empty: "Няма качено лого.",
    logo_alt: "Лого на компанията",
  },
  // Phase 3C.3 — automatic quotation reminders. Every state word here is a
  // SAFE UI state produced by the backend projection; the database enum, the
  // provider payload and the delivery machinery never reach the browser.
  reminders: {
    // Company settings
    settings_section: "Автоматични напомняния за нови оферти",
    settings_enabled_label: "Автоматични напомняния за нови оферти",
    settings_enabled_help:
      "При създаване на нова оферта OfferTrace автоматично ще създаде напомняния според зададения график.",
    settings_schedule_label: "График за напомняния",
    settings_schedule_help:
      "До {{max}} напомняния, всяко между {{min}} и {{maxDays}} дни преди датата на изтичане. 0 означава „В деня на изтичане“.",
    settings_schedule_empty: "Няма зададени напомняния.",
    settings_add_placeholder: "напр. 7",
    settings_add_label: "Дни преди изтичане",
    settings_add_action: "Добави",
    settings_remove_offset: "Премахни {{label}}",
    settings_full: "Достигнахте максимума от {{max}} напомняния.",
    settings_future_only:
      "Промяната важи само за оферти, създадени след запазването. Съществуващите оферти запазват своите напомняния.",

    // Quotation detail
    card_title: "Автоматични напомняния",
    next_title: "Следващо напомняне",
    no_next: "Няма предстоящо напомняне за тази оферта.",
    none_configured: "За тази оферта няма зададени напомняния.",
    // The card separates the CURRENT configuration from what already happened:
    // `days_before` is the current schedule, while the rules array is the
    // quotation's lifetime history.
    current_schedule_title: "Текущ график",
    sent_history_title: "История на изпратените напомняния",
    history_note: "(история)",
    retry_at: "следващ опит: {{when}}",
    expected_at: "очаквано изпращане: {{when}}",
    edit: "Промени",
    save: "Запази напомнянията",
    saving: "Запазване…",
    saved: "Напомнянията бяха запазени.",
    save_failed: "Напомнянията не бяха запазени. Опитайте отново.",
    editor_help:
      "Задайте до {{max}} напомняния, всяко между {{min}} и {{maxDays}} дни преди изтичане. Празният списък изключва бъдещите напомняния.",
    editor_empty: "Няма да бъдат изпращани напомняния за тази оферта.",
    add_placeholder: "напр. 3",
    add_label: "Дни преди изтичане",
    add_action: "Добави",
    remove_offset: "Премахни {{label}}",
    send_time_note: "Напомнянията се изпращат в {{time}} часа, {{timezone}}.",

    // New quotation form
    new_quotation_hint:
      "Ще бъдат приложени автоматичните настройки за напомняния на организацията.",
  },
  notifications: {
    title: "Известия",
    empty: "Нямате известия.",
    mark_read: "Маркирай като прочетено",
    mark_all_read: "Маркирай всички като прочетени",
    type_quotation_assigned: "Оферта възложена",
  },
  public: {
    header_offer_from: "Оферта от",
    tagline: "Всяка оферта получава отговор.",
    reference: "№ на оферта",
    valid_until: "Валидна до",
    accept: "Приемам офертата",
    ask_question: "Имам въпрос",
    decline: "Отказвам офертата",
    request_updated_quote: "Заявка за нова оферта",
    expired_banner: "Офертата е изтекла. Можете да заявите обновена оферта или да зададете въпрос.",
    terminal_banner: "Вече сте отговорили на тази оферта.",
    archived_banner: "Тази оферта вече не е активна и не приема отговори. За въпроси се свържете директно с нас.",
    thanks_accepted: "Благодарим! Отговорът ви е записан.",
    thanks_declined: "Благодарим за отговора.",
    thanks_question: "Благодарим! Ще се свържем скоро.",
    name: "Име",
    optional: "незадължително",
    message: "Съобщение",
    reason: "Причина",
    reasons: {
      price: "Цена",
      timing: "Срокове",
      other_supplier: "Избрахме друг доставчик",
      postponed: "Проектът е отложен",
      missing_requirement: "Липсва изискване",
      other: "Друго",
    },
    request_callback: "Искам обратно обаждане",
    submit: "Изпрати",
    confirm_accept_title: "Приемане на оферта",
    confirm_decline_title: "Отказ на оферта",
    question_title: "Задай въпрос",
    not_qualified_signature: "Записът не представлява квалифициран електронен подпис.",
    powered_by: "чрез OfferTrace",
  },
  // Phase 2D.1C — organization lifecycle gates. Shown to a member whose own
  // organization is not active. The server sends the exact Bulgarian title and
  // message; these are the fallbacks when it cannot be reached.
  lifecycle: {
    blocked_title: "Организацията не е достъпна",
    blocked_body:
      "Достъпът до тази организация е спрян. Свържете се с екипа на OfferTrace.",
    switch_hint: "Имате достъп до друга организация:",
    recheck: "Провери отново",
    rechecking: "Проверява се…",
  },
  // Phase 2D.1B — OfferTrace PLATFORM administration. Never shown to a customer
  // user: the console is reachable only for an active platform super
  // administrator, and the navigation entry is rendered only for them.
  platform: {
    title: "Платформена администрация",
    nav_link: "Платформа",
    organizations: "Организации",
    licenses: "Лицензи",
    checking_access: "Проверка на достъпа…",
    denied_title: "Нямате достъп до платформената администрация",
    denied_body: "Този раздел е достъпен само за администратори на OfferTrace.",
    back_to_app: "Към приложението",
    back_to_list: "Към организациите",
    signed_in_as: "Влезли сте като {{name}}",
    search_placeholder: "Търсене по име на организация",
    search: "Търси",
    clear_search: "Изчисти",
    refresh: "Обнови",
    open: "Отвори",
    empty: "Няма намерени организации",
    page_info: "{{from}}–{{to}} от {{total}}",
    prev: "Назад",
    next: "Напред",
    col_organization: "Организация",
    col_status: "Статус",
    col_valid_until: "Валиден до",
    col_updated: "Последна промяна",
    indefinite: "Безсрочен",
    over_limit: "Надвишен лимит",
    over_limit_hint:
      "Заетите места (активни потребители плюс чакащи покани) надвишават лицензираните места.",
    license_section: "Лиценз",
    seats_section: "Лицензни места",
    status_label: "Лицензионен статус",
    status_active: "Активен",
    status_suspended: "Спрян",
    status_expired: "Изтекъл",
    status_help:
      "Статусът се записва за целите на платформената администрация. Автоматичното ограничаване на достъпа на клиента ще бъде добавено в следваща фаза.",
    valid_from: "Валиден от",
    valid_until: "Валиден до",
    valid_until_help: "Оставете полето празно за безсрочен лиценз.",
    source: "Източник",
    source_manual: "Ръчно от администратор",
    source_migration: "Първоначално зареждане",
    source_bootstrap: "Създаване на организация",
    source_stripe: "Stripe",
    source_promotion: "Промоция",
    source_trial: "Пробен период",
    owner_seats: "Owner места",
    owner_seats_locked: "Owner местата са фиксирани на 1 и не могат да се променят.",
    manager_seats: "Мениджърски места",
    manager_seats_help: "0 означава, че мениджърската функционалност не е лицензирана.",
    sales_seats: "Места за продавачи",
    sales_seats_help:
      "Заетите места (активни търговци плюс чакащи покани) не могат да надвишават този лимит.",
    active_users: "Активни потребители",
    // Phase 2D.2 checkpoint 2B — the authoritative usage figure now counts active
    // members AND pending, non-expired invitations, so it may not be labelled
    // "активни потребители" any more.
    occupied_seats: "Заети места",
    occupied_seats_hint:
      "Заетите места включват активните потребители и местата, запазени от чакащи покани.",
    internal_note: "Вътрешна бележка",
    internal_note_help: "Вижда се само в платформената администрация.",
    updated_at: "Последна промяна",
    history: "История на промените",
    history_empty: "Няма записани промени",
    audit_license_updated: "Променен лиценз",
    audit_first_admin_bootstrapped: "Създаден първи администратор",
    audit_other: "Платформена промяна",
    audit_validity_changed: "Променена валидност",
    audit_note_changed: "Променена вътрешна бележка",
    save: "Запази промените",
    saving: "Запазване…",
    cancel: "Отказ",
    saved: "Промените са запазени.",
    no_changes: "Няма промени за запазване.",
    unsaved: "Има незапазени промени.",
    not_found: "Организацията не е намерена.",
    invalid_status: "Невалиден лицензионен статус.",
    // Phase 2D.1C — provisioning, the Owner invitation and the lifecycle state.
    // Every lifecycle ACTION (архивиране, възстановяване, изтриване) belongs to
    // a later checkpoint and has no string here on purpose.
    new_organization: "Нова организация",
    create_title: "Създаване на организация",
    create_lead:
      "Организацията се създава в състояние „Чака активация“. Собственикът получава покана по имейл и активира организацията сам. Owner местата са фиксирани на 1.",
    create_submit: "Създай и изпрати покана",
    creating: "Създаване…",
    created: "Организацията е създадена и поканата е изпратена.",
    created_delivery_failed:
      "Организацията е създадена, но поканата не беше изпратена.",
    delivery_not_sent: "Поканата не беше изпратена.",
    org_name: "Име на организацията",
    org_name_help: "Клиентът вижда това име в приложението.",
    organization_section: "Организация",
    save_organization: "Запази организацията",
    platform_note: "Вътрешна бележка за организацията",
    platform_note_help: "Вижда се само в платформената администрация. Клиентът никога не я вижда.",
    internal_note_too_long: "Вътрешната бележка може да е до 2000 знака.",
    dismiss: "Скрий",
    sending: "Изпращане…",
    owner_section: "Собственик",
    owner_first_name: "Име на собственика",
    owner_last_name: "Фамилия на собственика",
    owner_email: "Имейл на собственика",
    owner_email_help:
      "Поканата се изпраща на този адрес и може да бъде приета само от него.",
    owner_phone: "Телефон",
    owner_phone_help: "Незадължително.",
    owner_card: "Собственик и покана",
    owner_email_label: "Имейл",
    owner_name_label: "Име",
    owner_member_since: "Собственик от",
    owner_invited_to: "Покана до: {{email}}",
    no_owner_yet: "Няма собственик",
    invitation_email: "Изпратена до",
    invitation_phone: "Телефон",
    invitation_flow: "Начин на покана",
    invitation_expires: "Валидна до",
    invitation_expired: "изтекла",
    invitation_resend_count: "Повторни изпращания",
    invitation_none: "Няма чакаща покана.",
    invitation_history: "История на поканите",
    invitation_history_empty: "Няма покани.",
    inv_status_pending: "Чакаща",
    inv_status_accepted: "Приета",
    inv_status_revoked: "Оттеглена",
    inv_status_expired: "Изтекла",
    inv_accepted_at: "приета",
    inv_revoked_at: "оттеглена",
    flow_new_user: "Нов потребител — покана през Supabase",
    flow_existing_user: "Съществуващ потребител — защитен имейл",
    delivery_label: "Доставка",
    delivery_unsent: "Не е изпратена",
    delivery_sending: "Изпраща се",
    delivery_sent: "Изпратена",
    delivery_failed: "Неуспешно изпращане",
    delivery_error_email_disabled: "Изпращането на имейли е изключено в тази среда.",
    delivery_error_security_sender: "Няма конфигуриран защитен изпращач за покани.",
    delivery_error_supabase_rejected: "Supabase отказа поканата за нов потребител.",
    delivery_error_failed: "Имейлът не беше приет от доставчика. Опитайте отново.",
    resend_invitation: "Изпрати поканата отново",
    resent: "Поканата е изпратена отново. Предишната връзка вече не е валидна.",
    replace_owner: "Смени собственика",
    replace_title: "Смяна на поканения собственик",
    replace_lead:
      "Старата покана се оттегля и веднага се издава нова. Организацията остава в „Чака активация“.",
    replace_submit: "Запази и изпрати нова покана",
    replaced: "Поканата е издадена на новия собственик.",
    lifecycle_section: "Жизнен цикъл",
    lifecycle_pending_activation: "Чака активация",
    lifecycle_active: "Активна",
    lifecycle_archived: "Архивирана",
    lifecycle_deletion_pending: "Чака изтриване",
    lifecycle_unknown: "Неизвестно състояние",
    filter_all: "Всички",
    filter_pending_activation: "Чакащи активация",
    filter_active: "Активни",
    filter_archived: "Архивирани",
    filter_deletion_pending: "Чакащи изтриване",
    col_lifecycle: "Състояние",
    col_owner: "Собственик",
    created_at: "Създадена",
    activated_at: "Активирана",
    archived_at: "Архивирана на",
    deletion_requested_at: "Заявено изтриване",
    delete_after: "Изтриване след",
    blocks_tenant_access:
      "Докато организацията не е активна, достъпът на клиента е блокиран.",
    audit_organization_created: "Създадена организация",
    audit_organization_updated: "Променена организация",
    audit_organization_activated: "Активирана организация",
    audit_owner_invitation_created: "Създадена покана за собственик",
    audit_owner_invitation_resent: "Поканата е изпратена отново",
    audit_owner_invitation_replaced: "Сменен поканен собственик",
    audit_owner_invitation_accepted: "Приета покана за собственик",
    audit_owner_invitation_delivery_failed: "Неуспешно изпращане на покана",
    audit_name_changed: "Променено име",
    audit_lifecycle_changed: "Променено състояние: {{before}} → {{after}}",
    // Phase 2D.1C checkpoint 3 — the destructive lifecycle: архивиране,
    // възстановяване, заявка за изтриване с гратисен период и окончателно
    // изтриване. Всяко действие се извършва само от платформен администратор и
    // се проверява отново от сървъра в момента на изпълнение.
    danger_section: "Опасна зона",
    danger_lead:
      "Тези действия засягат достъпа на клиента и неговите данни. Всяко действие се записва в историята.",
    no_actions: "Няма налични действия за това състояние.",
    archive_action: "Архивирай организацията",
    archive_title: "Архивиране на организацията",
    archive_body:
      "Достъпът на клиента спира веднага. Никакви данни не се изтриват и архивирането може да бъде отменено. Чакаща покана за собственик се оттегля.",
    archive_confirm: "Архивирай",
    archiving: "Архивиране…",
    archived_notice: "Организацията е архивирана. Достъпът на клиента е спрян.",
    restore_action: "Възстанови организацията",
    restore_title: "Възстановяване на организацията",
    restore_body_active:
      "Организацията се връща в „Активна“ със същия собственик и достъпът на клиента се възстановява.",
    restore_body_pending:
      "Организацията никога не е била активирана и се връща в „Чака активация“. Издава се нова покана за собственик и се изпраща по имейл.",
    restore_confirm: "Възстанови",
    restoring: "Възстановяване…",
    restored_notice: "Организацията е възстановена.",
    restored_invitation_notice:
      "Организацията е възстановена и е издадена нова покана за собственик.",
    deletion_request_action: "Заяви окончателно изтриване",
    deletion_request_title: "Заявка за окончателно изтриване",
    deletion_request_lead:
      "Организацията остава архивирана още {{days}} дни. През този период заявката може да бъде отменена. След крайния срок платформен администратор може да изтрие организацията окончателно.",
    deletion_request_submit: "Заяви изтриване",
    deletion_requested_notice:
      "Заявката за изтриване е приета. Окончателно изтриване е възможно след {{deadline}}.",
    deletion_cancel_action: "Отмени заявката за изтриване",
    deletion_cancel_title: "Отмяна на заявката за изтриване",
    deletion_cancel_body:
      "Заявката се отменя и организацията остава архивирана. Никакви данни не са били изтрити.",
    deletion_cancel_confirm: "Отмени заявката",
    deletion_cancelling: "Отмяна…",
    deletion_cancelled_notice: "Заявката за изтриване е отменена.",
    confirm_name_label: "Напишете точното име на организацията",
    confirm_name_help: "Въведете „{{name}}“, за да потвърдите действието.",
    confirm_name_mismatch: "Името не съвпада точно с името на организацията.",
    purge_action: "Изтрий окончателно",
    purge_title: "Окончателно изтриване",
    purge_lead:
      "Действието е необратимо. Всички данни на организацията и всички качени файлове се изтриват без възможност за възстановяване.",
    purge_preview_loading: "Изчисляване на данните за изтриване…",
    purge_preview_title: "Какво ще бъде изтрито",
    purge_impact_empty: "Няма записи за изтриване.",
    purge_rows_total: "Общо записи в базата",
    purge_storage_total: "Общо файлове",
    purge_ack: "Разбирам, че действието е необратимо.",
    purge_server_note:
      "Сървърът проверява състоянието, крайния срок и името отново в момента на изтриването.",
    purge_submit: "Изтрий окончателно",
    purging: "Изтриване…",
    purged: "Организацията и всички нейни данни са изтрити окончателно.",
    purge_blocked_generic: "Окончателното изтриване не е разрешено в момента.",
    purge_deadline: "Окончателно изтриване е възможно след {{deadline}}.",
    purge_job_section: "Последен опит за изтриване",
    purge_job_status: "Състояние",
    purge_job_attempts: "Опити",
    purge_job_files: "Изтрити файлове",
    purge_job_updated: "Последна промяна",
    purge_job_status_running: "В процес",
    purge_job_status_completed: "Приключил",
    purge_job_status_failed: "Неуспешен",
    purge_retry_hint: "Нищо не е изтрито наполовина. Можете да опитате отново.",
    purge_error_storage:
      "Част от файловете не бяха изтрити, затова базата данни не беше променена.",
    purge_error_grace: "Гратисният период още не е изтекъл.",
    purge_error_name: "Името не съвпадна с името на организацията.",
    purge_error_state: "Организацията няма активна заявка за изтриване.",
    purge_error_job: "Процесът по изтриване вече е приключил.",
    purge_error_failed: "Окончателното изтриване не завърши.",
    purge_table_quotations: "Оферти",
    purge_table_quotation_files: "Прикачени файлове",
    purge_table_quotation_public_links: "Публични връзки",
    purge_table_quotation_events: "Събития по оферти",
    purge_table_quotation_responses: "Отговори от клиенти",
    purge_table_quotation_emails: "Изпратени имейли",
    purge_table_quotation_email_events: "Събития по имейли",
    purge_table_customers: "Клиенти",
    purge_table_internal_notifications: "Известия",
    purge_table_audit_logs: "Одитни записи",
    purge_table_organization_members: "Членове",
    purge_table_organization_member_invitations: "Покани за членове",
    purge_table_organization_teams: "Екипи",
    purge_table_organization_team_members: "Членства в екипи",
    purge_table_organization_owner_invitations: "Покани за собственик",
    purge_table_organization_role_entitlements: "Лицензни места",
    purge_table_organization_licenses: "Лицензи",
    purge_table_organization_platform_metadata: "Вътрешни бележки",
    purge_table_platform_audit_logs: "Платформени одитни записи",
    audit_organization_archived: "Архивирана организация",
    audit_organization_restored: "Възстановена организация",
    audit_organization_deletion_requested: "Заявено окончателно изтриване",
    audit_organization_deletion_cancelled: "Отменена заявка за изтриване",
    audit_organization_purge_started: "Започнало окончателно изтриване",
    audit_organization_purged: "Организацията е изтрита окончателно",
    audit_organization_purge_failed: "Неуспешно окончателно изтриване",
  },
  // Phase 2D.1C — Owner invitation acceptance. The only screen that activates an
  // organization provisioned by an OfferTrace platform administrator.
  invite: {
    title: "Покана за собственик",
    side_note:
      "Поканата е лична, може да се използва само веднъж и се приема с имейла, на който сте я получили.",
    checking: "Проверка на поканата…",
    organization: "Организация",
    valid_title: "Приемете поканата",
    valid_lead:
      "OfferTrace Ви определи за собственик на „{{name}}“. След приемане организацията се активира и можете да започнете работа.",
    accept: "Приемам поканата",
    accepting: "Приемане…",
    expires_at: "Валидна до",
    requires_auth_title: "Влезте в профила си",
    requires_auth_body:
      "Влезте с имейл адреса, на който получихте поканата, и отворете връзката от имейла отново.",
    go_to_login: "Към входа",
    set_password_title: "Задайте парола",
    set_password_lead:
      "Създайте парола за акаунта си в OfferTrace. След това поканата се приема автоматично.",
    set_password_submit: "Задай паролата и приеми",
    success_title: "Организацията е активирана",
    success_lead: "Вече сте собственик на „{{name}}“.",
    go_to_app: "Към приложението",
    already_title: "Поканата вече е приета",
    already_body: "Можете да влезете в организацията.",
    refused_title: "Поканата не може да бъде приета",
    link_error_title: "Връзката не е валидна",
    link_error_body:
      "Връзката не може да бъде използвана. Помолете OfferTrace да Ви изпрати нова покана.",
    link_expired_body:
      "Срокът на връзката е изтекъл. Помолете OfferTrace да Ви изпрати нова покана.",
    error_generic: "Възникна грешка. Опитайте отново по-късно.",
  },
  // Phase 2D.2A — password recovery and reset. The password is changed only
  // through a one-time link sent to the verified account e-mail.
  password: {
    forgot_title: "Забравена парола",
    forgot_lead:
      "Въведете имейла на акаунта си и ще ви изпратим линк за смяна на паролата.",
    forgot_side_note:
      "Смяната на паролата става само чрез еднократен защитен линк, изпратен до имейла на акаунта.",
    send_link: "Изпрати линк",
    sending: "Изпращане…",
    neutral_sent:
      "Ако съществува акаунт с този имейл, ще получите линк за смяна на паролата.",
    back_to_login: "Назад към входа",
    cooldown: "Можете да заявите нов линк след {{seconds}} сек.",
    invalid_email: "Въведете валиден имейл адрес.",
    reset_title: "Нова парола",
    reset_lead: "Изберете нова парола за вашия акаунт.",
    reset_side_note: "Линкът е еднократен и е валиден ограничено време.",
    verifying: "Проверка на връзката…",
    new_password: "Нова парола",
    repeat_password: "Повторете новата парола",
    show: "Покажи паролата",
    hide: "Скрий паролата",
    submit: "Запази новата парола",
    submitting: "Запазване…",
    requirements_title: "Паролата трябва да съдържа:",
    rule_length: "Поне 8 символа",
    rule_lowercase: "Поне една малка буква",
    rule_uppercase: "Поне една главна буква",
    rule_digit: "Поне една цифра",
    rule_special: "Поне един специален символ, напр. ! ? # $ % (интервалът не се брои)",
    rule_match: "Двете пароли съвпадат",
    error_policy: "Паролата не отговаря на изискванията.",
    error_mismatch: "Паролите не съвпадат.",
    error_same: "Новата парола трябва да е различна от текущата.",
    error_generic: "Паролата не беше променена. Опитайте отново.",
    link_invalid_title: "Връзката е невалидна или вече е използвана",
    link_invalid_body:
      "Линковете за смяна на паролата са еднократни и с ограничен срок. Заявете нов линк.",
    link_expired_body: "Линкът за смяна на паролата е изтекъл. Заявете нов линк.",
    request_new_link: "Заявете нов линк",
    denied_title: "Няма активна заявка за смяна на паролата",
    denied_body:
      "Тази страница се отваря само чрез линка, изпратен до имейла на акаунта. Паролата не може да бъде сменена директно от активна сесия.",
    success_title: "Готово",
    success_body: "Паролата е променена успешно. Влезте с новата си парола.",
    go_to_login: "Към входа",
  },
  // Phase 2D.2B — signup e-mail confirmation. The organization is created only
  // after the address is verified, by the /auth/confirm-signup callback.
  signup: {
    check_email_title: "Проверете имейла си",
    check_email_body: "Изпратихме Ви линк за потвърждение на имейл адреса.",
    check_email_sent_to: "Изпратен до",
    steps_title: "Как да завършите регистрацията:",
    step_1: "Отворете получения имейл.",
    step_2: "Натиснете „Потвърди имейл адреса“.",
    step_3: "OfferTrace ще завърши създаването на акаунта и организацията Ви.",
    step_4: "Ще бъдете пренасочени към страницата за вход.",
    step_5: "Влезте с имейла и паролата, които създадохте.",
    org_note: "Не е необходимо да попълвате повторно данните за организацията.",
    resend: "Изпрати имейла отново",
    resending: "Изпращане…",
    resent: "Ако имейл адресът все още не е потвърден, изпратихме нов линк за потвърждение.",
    cooldown: "Можете да заявите нов имейл след {{seconds}} сек.",
    back_to_login: "Към входа",
    error_generic: "Регистрацията не беше приета. Проверете данните и опитайте отново.",
    error_rate_limited: "Твърде много опити. Опитайте отново след няколко минути.",
    confirm_title: "Потвърждаване на имейл адреса",
    confirm_side_note:
      "Потвърждаваме имейл адреса и завършваме създаването на акаунта и организацията Ви.",
    verifying: "Потвърждаване на имейл адреса…",
    completing: "Завършваме създаването на акаунта и организацията Ви…",
    success_title: "Готово",
    confirmed_notice:
      "Имейл адресът е потвърден и акаунтът Ви е активиран. Влезте с имейла и паролата, които създадохте.",
    go_to_login: "Към входа",
    failed_title: "Регистрацията не е завършена",
    failed_body:
      "Имейлът Ви е потвърден, но регистрацията не можа да бъде завършена. Опитайте отново.",
    retry: "Завърши регистрацията",
    no_pending_body:
      "Не намерихме данните за организацията от вашата регистрация. Регистрирайте се отново, за да завършим създаването ѝ.",
    restart: "Регистрирайте се отново",
    link_invalid_title: "Връзката за потвърждение е невалидна или вече е използвана",
    link_invalid_body:
      "Линковете за потвърждение са еднократни и с ограничен срок. Регистрирайте се отново, за да получите нов линк.",
    link_expired_body:
      "Линкът за потвърждение е изтекъл. Регистрирайте се отново, за да получите нов линк.",
    already_title: "Регистрацията вече е завършена",
    already_body: "Акаунтът и организацията Ви вече са активни.",
    go_to_app: "Към приложението",
  },
  // Phase 2D.2A — personal account page. Organization-level settings stay in
  // `company`; nothing here belongs to the organization.
  profile: {
    title: "Моят профил",
    account_section: "Данни за акаунта",
    account_email: "Имейл на акаунта",
    account_name: "Име",
    account_readonly_note:
      "Редактирането на личните данни ще бъде добавено в следваща версия.",
    security_section: "Сигурност",
    security_lead:
      "Паролата се сменя само чрез еднократен защитен линк, изпратен до имейла на вашия акаунт.",
    security_destination: "Линкът ще бъде изпратен до",
    send_reset_link: "Изпрати линк за смяна на паролата",
    sending: "Изпращане…",
    reset_link_sent:
      "Изпратихме линк за смяна на паролата до имейла на вашия акаунт.",
    cooldown: "Можете да заявите нов линк след {{seconds}} сек.",
  },
  // Phase 4A.5A — the in-app Assistant panel. Every failure sentence here is
  // FRONTEND copy keyed by an allowlisted code: only an `answer` renders text
  // the server produced, so no unexpected body can be shown as a message.
  assistant: {
    title: "AI асистент",
    open: "Отвори AI асистента",
    close: "Затвори AI асистента",
    notice:
      "Асистентът само отговаря на въпроси за работата с OfferTrace. "
      + "Той не създава и не променя оферти, клиенти, потребители или настройки.",
    empty: "Задайте въпрос за работата с OfferTrace.",
    conversation: "Разговор с AI асистента",
    input_label: "Вашият въпрос",
    placeholder: "Напишете въпроса си…",
    send: "Изпрати",
    sending: "Изпращане…",
    loading: "Асистентът обработва въпроса…",
    reset: "Нов разговор",
    author_user: "Вие",
    author_assistant: "Асистент",
    counter: "{{used}} / {{max}} символа",
    session_note:
      "Разговорът се пази само временно в текущата сесия. Изчиства се при "
      + "презареждане, изход, смяна на организация или „Нов разговор“.",
    too_long: "Въпросът е твърде дълъг. Съкратете го до {{max}} символа.",
    empty_message: "Напишете въпрос, преди да изпратите.",
    state_insufficient_evidence:
      "Не разполагам с достатъчно потвърдена информация, за да отговоря надеждно.",
    state_assistant_unavailable:
      "AI асистентът временно не е достъпен. Опитайте отново по-късно.",
    state_unauthenticated:
      "Сесията ви изтече. Влезте отново, за да използвате асистента.",
    state_forbidden: "Нямате достъп до AI асистента за тази организация.",
    state_rate_limited:
      "Твърде много въпроси за кратко време. Изчакайте малко и опитайте отново.",
    state_invalid_request:
      "Въпросът не може да бъде обработен в този вид. Преформулирайте го.",
    state_failed: "Възникна грешка. Опитайте отново.",
  },
};

const en = { ...bg }; // scaffold; English translations added later

i18n.use(initReactI18next).init({
  lng: "bg",
  fallbackLng: "bg",
  interpolation: { escapeValue: false },
  resources: {
    bg: { translation: bg },
    en: { translation: en },
  },
});

export default i18n;
